import React from "react";

import { NavigationControl as UrbicaNavigationControl } from "@urbica/react-map-gl";

const NavigationControl = () => {
    return <UrbicaNavigationControl position="top-left" showZoom showCompass visualizePitch />;
};

export default NavigationControl;
